<template>
    <!-- 跟多-暂缓 弹屏 -->
    <a-modal
      v-model="isSuspend"
      destroyOnClose
      :footer="null"
      :maskClosable="false"
      :closable="false"
      :width="700"
      centered
    >
      <div class="suspend">
        <div class="title">
          <a-icon @click="close" style="font-size: 16px; cursor: pointer" type="close" />
          <span>暂缓原因</span>
          <span style="font-size: 16px; color: var(--ThemeColor); cursor: pointer" @click="suspendOk">提交</span>
        </div>
        <div class="content">
          <textarea v-model="suspend.suspendedReason" class="textarea" placeholder="请输入暂缓原因"></textarea>
        </div>
      </div>
    </a-modal>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js'
import sell_touristApi from '@/api/system/tourist/sell_tourist.js'

export default {
    props:{
        userInfo:{
            type:Object,
            default:()=>({})
        },
        type:{
            type:String,
            default:''
        }
    },
    watch:{
        userInfo:{
            handler(){},
            deep:true,
            immediate:true
        }
    },
    data(){
        return {
            isSuspend:false,
             // 修改暂缓-参数
            suspend: {
                id: this.$route.query.id,
                identity: '6', // 标识（1：五，3：优，5:意向，6:暂缓）
                identityStr: 'Y',
                suspendedReason: ''
            },
        }
    },
    methods:{
        open(){
            this.isSuspend = true
        },
        // 关闭暂缓弹窗
        close () {
            this.suspend.suspendedReason = ''
            this.isSuspend = false
        },
        // 设置暂缓
        suspendOk () {
            const { isSuspended } = this.userInfo
            let port = this.type === 'sale'? sell_touristApi : touristApi
            if (isSuspended && isSuspended === 'Y') {
                this.suspend.identityStr = 'N'
                port.editIdentity({ ...this.suspend }).then((res) => {
                    if (res.code === 200) {
                        this.$message.success('取消暂缓成功')
                        this.close()
                        // this.getUserInfo()
                        this.success()
                    }
                })
            } else {
                this.suspend.identityStr = 'Y'
                port.editIdentity({ ...this.suspend }).then((res) => {
                    if (res.code === 200) {
                        this.$message.success('设置暂缓成功')
                        this.close()
                        // this.getUserInfo()
                        // this.getRecordList()
                        this.success()
                    }
                })
            }
        },
        // 成功提交
        success(){
            this.$emit('onSuccess')
        }
    }
}
</script>

<style lang="less" scoped>
//暂缓 弹窗
.suspend {
  .title {
    height: 20px;
    line-height: 20px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .textarea {
    margin-top: 20px;
    width: 100%;
    height: 160px;
    outline: none;
    border-radius: 10px;
    border-color: #f1f2f3;
    padding: 10px;
    margin-bottom: 20px;
    resize: none;
    overflow: hidden;
  }
}
</style>